import styled from 'styled-components';
import { FiTrash2 } from 'react-icons/fi';
import { FormGroup } from './CreateSharingModalStyles';

export const SharedCardsSection = styled.section`
  width: 100%;
  margin-top: 3rem;
  padding: 0 1.5rem;

  @media (min-width: 768px) {
    padding: 0;
  }
`;

export const SharedCardsSectionTitle = styled.h2`
  color: ${(props) => props.theme.colors.palet.institutional3};
  text-transform: uppercase;
  font-family: 'Unimed-Sans-SemiBold', serif;
  font-size: 1.62rem;
  margin-bottom: 2rem;
`;

export const SharedCardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const SharedCardItem = styled.div`
  background: ${(props) => props.theme.colors.background};
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid ${(props) => props.theme.colors.palet.institutional13};
  transition: all 300ms ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const CardInfo = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const HolderName = styled.h3`
  color: ${(props) => props.theme.colors.palet.institutional3};
  font-family: 'Unimed-Sans-SemiBold';
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
`;

export const CardNumber = styled.p`
  color: ${(props) => props.theme.colors.text.grayishToLightGray};
  font-family: 'Unimed-Sans-Book';
  font-size: 1rem;
  letter-spacing: 1px;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const ActionButton = styled.button`
  background: transparent;
  border: 2px solid ${(props) => props.theme.colors.palet.institutional};
  color: ${(props) => props.theme.colors.palet.institutional};
  border-radius: 25px;
  padding: 0.75rem 1.5rem;
  font-family: 'Unimed-Sans-SemiBold', serif;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 300ms ease;
  white-space: nowrap;

  &:hover {
    background: ${(props) => props.theme.colors.palet.institutional};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 153, 93, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    flex: 1;
    min-width: 120px;
  }
`;

export const SharedWithTitle = styled.h4`
  color: ${(props) => props.theme.colors.text.grayishToLightGray};
  font-family: 'Unimed-Sans-SemiBold';
  font-size: 1rem;
  margin-bottom: 1rem;
`;

export const SharedWithList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SharedPersonItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: ${(props) =>
    props.theme.title === 'light'
      ? props.theme.colors.palet.institutional14
      : props.theme.colors.palet.institutional12};
  border-radius: 12px;
  transition: all 300ms ease;

  &:hover {
    background: ${(props) => props.theme.colors.palet.institutional13};
  }
`;

export const PersonInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
`;

export const PersonAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.palet.institutional4};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Unimed-Sans-SemiBold', serif;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.palet.institutional2};
  text-transform: uppercase;
`;

export const PersonDetails = styled.div`
  flex: 1;
`;

export const PersonName = styled.p`
  color: ${(props) => props.theme.colors.text.normal};
  font-family: 'Unimed-Sans-SemiBold';
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
`;

export const PersonPhone = styled.p`
  color: ${(props) => props.theme.colors.text.grayishToLightGray};
  font-family: 'Unimed-Sans-Book';
  font-size: 0.85rem;
`;

export const DeleteButton = styled.button`
  background: transparent;
  border: none;
  color: ${(props) => props.theme.colors.text.grayishToLightGray};
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 300ms ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${(props) => props.theme.colors.palet.institutional7}20;
    color: ${(props) => props.theme.colors.palet.institutional7};
    transform: scale(1.1);
  }
`;

export const DeleteIcon = styled(FiTrash2)`
  font-size: 1.1rem;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 1.5rem;
  color: ${(props) => props.theme.colors.text.grayishToLightGray};
  font-family: 'Unimed-Sans-Book';
  font-size: 1rem;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ShareButton = styled.button`
  background: ${(props) => props.theme.colors.palet.institutional};
  color: white;
  border: none;
  border-radius: 25px;
  padding: 0.75rem 1.5rem;
  font-family: 'Unimed-Sans-SemiBold', serif;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 300ms ease;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 153, 93, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: #007a4a;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 153, 93, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background: #cccccc;
    color: #666666;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }

  svg {
    transition: transform 300ms ease;
  }

  &:hover:not(:disabled) svg {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    align-self: center;
    min-width: 200px;
  }
`;

export const StartSharingModalText = styled.p`
  text-align: center;
  margin-bottom: 1rem;
`;

export const LegalInformationModalText = styled.p`
  text-align: justify;
  margin-bottom: 1rem;
`;

export const CheckboxGroup = styled(FormGroup)`
  display: flex;
  align-items: center;
  label {
    font-size: 1rem;
    margin-bottom: 0;
  }
`;
